(function () {
    var EC_FREE_SHIPPING_BAR_SESSION = 'ec_cart_drawer_free_shipping_bar';
    var globalApplySelection = null;

    function getRegionRules() {
        const host = document.getElementById('ec-free-shipping-bar-host');
        const attr = (name) => (host && host.getAttribute(name)) || '';
        const states = (name) => attr(name).split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
        const threshold = (name) => {
            const val = parseFloat(attr(name));
            return isNaN(val) ? 0 : val;
        };
        return {
            region1: { states: states('data-region1-states'), threshold: threshold('data-region1-threshold') },
            region2: { states: states('data-region2-states'), threshold: threshold('data-region2-threshold') },
            region3: { states: states('data-region3-states'), threshold: threshold('data-region3-threshold') }
        };
    }

    function isAnyRegionConfigured() {
        const rules = getRegionRules();
        return rules.region1.states.length > 0 ||
            rules.region2.states.length > 0 ||
            rules.region3.states.length > 0;
    }

    function getDynamicThresholdCents() {
        if (!isAnyRegionConfigured()) {
            return null;
        }
        try {
            const savedUf = sessionStorage.getItem('ec_calculated_uf');
            if (savedUf) {
                const rules = getRegionRules();
                const ufUpper = savedUf.toUpperCase();
                if (rules.region1.states.includes(ufUpper)) {
                    return rules.region1.threshold * 100;
                } else if (rules.region2.states.includes(ufUpper)) {
                    return rules.region2.threshold * 100;
                } else if (rules.region3.states.includes(ufUpper)) {
                    return rules.region3.threshold * 100;
                }
                return null;
            }
        } catch (e) { }
        const barEl = document.getElementById('ec-free-shipping-bar');
        if (barEl) {
            const val = parseInt(barEl.getAttribute('data-threshold-cents'), 10);
            return isNaN(val) ? null : val;
        }
        return null;
    }

    function updateFreeShippingBarUI(cartTotalCents) {
        const barEl = document.getElementById('ec-free-shipping-bar');
        if (!barEl) return;

        const host = document.getElementById('ec-free-shipping-bar-host');
        const reveal = document.getElementById('ec-free-shipping-reveal');

        if (!isAnyRegionConfigured()) {
            if (host) host.hidden = true;
            if (reveal) reveal.hidden = true;
            return;
        }

        let thresholdCents = getDynamicThresholdCents();
        if (thresholdCents === null || isNaN(thresholdCents) || thresholdCents <= 0) {
            if (host) host.hidden = true;
            if (reveal) reveal.hidden = true;
            return;
        }

        const isFree = cartTotalCents >= thresholdCents;
        const fillEl = barEl.querySelector('.ec-free-shipping-bar__fill');
        const markerEl = barEl.querySelector('.ec-free-shipping-bar__marker');
        const textEl = barEl.querySelector('.ec-free-shipping-bar__text');

        if (isFree) {
            barEl.classList.add('ec-free-shipping-bar--achieved');
            if (textEl) {
                textEl.innerHTML = `<strong>Você ganhou frete grátis!</strong>`;
            }
            if (fillEl) fillEl.style.width = '100%';
            if (markerEl) markerEl.style.left = '100%';
        } else {
            barEl.classList.remove('ec-free-shipping-bar--achieved');
            const remainingCents = thresholdCents - cartTotalCents;
            const remainingReais = remainingCents / 100;
            const remainingFormatted = 'R$ ' + remainingReais.toFixed(2).replace('.', ',');

            if (textEl) {
                textEl.innerHTML = `Faltam <strong>${remainingFormatted}</strong> para ganhar frete grátis!`;
            }
            const progressPercent = Math.min(100, Math.max(0, (cartTotalCents * 100) / thresholdCents));
            if (fillEl) fillEl.style.width = `${progressPercent}%`;
            if (markerEl) markerEl.style.left = `${progressPercent}%`;
        }
    }

    function setFreeShippingBarRevealed(revealed, persist) {
        var host = document.getElementById('ec-free-shipping-bar-host');
        var reveal = document.getElementById('ec-free-shipping-reveal');
        if (!host || !reveal) return;

        if (!isAnyRegionConfigured()) {
            host.hidden = true;
            reveal.hidden = true;
            return;
        }

        try {
            const savedUf = sessionStorage.getItem('ec_calculated_uf');
            if (savedUf) {
                const rules = getRegionRules();
                const ufUpper = savedUf.toUpperCase();
                const isMatched = rules.region1.states.includes(ufUpper) ||
                    rules.region2.states.includes(ufUpper) ||
                    rules.region3.states.includes(ufUpper);
                if (!isMatched) {
                    host.hidden = true;
                    reveal.hidden = true;
                    return;
                }
            }
        } catch (e) { }

        host.hidden = !revealed;
        reveal.hidden = revealed;
        if (persist) {
            try {
                if (revealed) {
                    sessionStorage.setItem(EC_FREE_SHIPPING_BAR_SESSION, '1');
                } else {
                    sessionStorage.removeItem(EC_FREE_SHIPPING_BAR_SESSION);
                }
            } catch (e) { }
        }
    }

    function syncFreeShippingBarFromSession() {
        var host = document.getElementById('ec-free-shipping-bar-host');
        var reveal = document.getElementById('ec-free-shipping-reveal');
        if (!host || !reveal) {
            return;
        }
        if (!isAnyRegionConfigured()) {
            host.hidden = true;
            reveal.hidden = true;
            return;
        }
        try {
            const savedUf = sessionStorage.getItem('ec_calculated_uf');
            if (savedUf) {
                const rules = getRegionRules();
                const ufUpper = savedUf.toUpperCase();
                const isMatched = rules.region1.states.includes(ufUpper) ||
                    rules.region2.states.includes(ufUpper) ||
                    rules.region3.states.includes(ufUpper);
                if (!isMatched) {
                    host.hidden = true;
                    reveal.hidden = true;
                    return;
                }
            }
        } catch (e) { }
        try {
            if (sessionStorage.getItem(EC_FREE_SHIPPING_BAR_SESSION) === '1') {
                setFreeShippingBarRevealed(true, false);
            } else {
                setFreeShippingBarRevealed(false, false);
            }
        } catch (e) { }
    }

    function initFreeShippingReveal() {
        var reveal = document.getElementById('ec-free-shipping-reveal');
        if (reveal && !reveal.__ecFreeShippingRevealBound) {
            reveal.__ecFreeShippingRevealBound = true;
            reveal.addEventListener('click', function () {
                var cep = document.getElementById('ec-cep-input');
                if (cep) {
                    cep.focus();
                    cep.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }
        syncFreeShippingBarFromSession();
    }

    function initShippingCalculator() {
        initFreeShippingReveal();

        const calculateButton = document.getElementById('ec-cart-shipping-calculate');
        if (!calculateButton) return;
        if (calculateButton.__ecShippingInitialized) return;
        calculateButton.__ecShippingInitialized = true;

        const zipCodeInput = document.getElementById('ec-cep-input');
        const shippingResult = document.getElementById('ec-cart-shipping-result');
        const inputGroup = document.getElementById('ec-cep-input-group');
        const freteSelected = document.getElementById('ec-cart-frete-selected');
        const freteCep = document.getElementById('ec-cart-frete-cep');
        const fretePrice = document.getElementById('ec-cart-frete-price');

        try {
            const savedCep = sessionStorage.getItem('ec_calculated_cep') || '';
            const savedUf = sessionStorage.getItem('ec_calculated_uf') || '';
            if (savedCep && savedUf && typeof window.syncCheckoutAddressInputs === 'function') {
                window.syncCheckoutAddressInputs(savedCep, savedUf);
            }
        } catch (e) {}

        function applySelection(optionEl) {
            if (!optionEl) return;
            const selectOptions = shippingResult.querySelectorAll('.ec-shipping-select-option');
            selectOptions.forEach(opt => opt.classList.remove('selected'));
            optionEl.classList.add('selected');
            const price = parseFloat(optionEl.getAttribute('data-price'));
            const name = optionEl.getAttribute('data-name');
            const delivery = optionEl.getAttribute('data-delivery');
            window.selectedShippingPrice = price;
            window.selectedShippingName = name;
            window.selectedShippingDelivery = delivery;

            if (inputGroup && freteSelected) {
                inputGroup.style.display = 'none';
                freteSelected.style.display = 'flex';
                if (freteCep) freteCep.textContent = 'CEP ' + (zipCodeInput ? zipCodeInput.value : '');
                if (fretePrice) fretePrice.textContent = formatMoney(price);
                if (shippingResult) shippingResult.style.display = 'none';
            }
            updateShippingSummary(price);
            updateCartTotal();

            try {
                const savedCep = sessionStorage.getItem('ec_calculated_cep') || '';
                const savedUf = sessionStorage.getItem('ec_calculated_uf') || '';
                if (typeof window.syncCheckoutAddressInputs === 'function') {
                    window.syncCheckoutAddressInputs(savedCep, savedUf);
                }
            } catch (e) {}
            document.dispatchEvent(new CustomEvent('ecShippingSelected'));
        }
        globalApplySelection = applySelection;

        calculateButton.addEventListener('click', async function () {
            const loadingImg = calculateButton.querySelector('.ec-shipping-loading');
            const buttonSpan = calculateButton.querySelector('span');

            if (!zipCodeInput || !shippingResult) return;

            var zipCode = zipCodeInput.value;

            zipCode = zipCode.replace(/\D/g, '');
            if (zipCode.length === 8) {
                zipCode = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
                zipCodeInput.value = zipCode;
                try {
                    sessionStorage.setItem('ec_calculated_cep', zipCode);
                } catch (e) {}
            } else {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                zipCodeInput.classList.add('error');
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
                return;
            }

            calculateButton.disabled = true;
            if (loadingImg) loadingImg.style.display = 'inline-block';
            if (buttonSpan) buttonSpan.style.display = 'none';
            shippingResult.innerHTML = '';

            var province = '';
            try {
                let response = await fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`);
                let data = await response.json();

                if (data.uf) {
                    province = data.uf;
                    const ufUpper = province.toUpperCase();
                    try {
                        sessionStorage.setItem('ec_calculated_uf', ufUpper);
                    } catch (e) { }
                    const barEl = document.getElementById('ec-free-shipping-bar');
                    let thresholdCents = null;
                    if (barEl) {
                        const val = parseInt(barEl.getAttribute('data-threshold-cents'), 10);
                        if (!isNaN(val)) thresholdCents = val;
                    }
                    const rules = getRegionRules();
                    let matched = false;
                    if (rules.region1.states.includes(ufUpper)) {
                        thresholdCents = rules.region1.threshold * 100;
                        matched = true;
                    } else if (rules.region2.states.includes(ufUpper)) {
                        thresholdCents = rules.region2.threshold * 100;
                        matched = true;
                    } else if (rules.region3.states.includes(ufUpper)) {
                        thresholdCents = rules.region3.threshold * 100;
                        matched = true;
                    }
                    try {
                        if (matched) {
                            sessionStorage.setItem('ec_region_threshold', thresholdCents.toString());
                        } else {
                            sessionStorage.removeItem('ec_region_threshold');
                        }
                    } catch (e) { }
                } else {
                    throw new Error("Não foi possível determinar o estado para o CEP fornecido.");
                }
            } catch (error) {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                zipCodeInput.classList.add('error');
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
                console.error('Erro:', error);
                return;
            }

            try {
                const shippingRates = await fetchShippingRates(zipCode, province);

                let cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
                let cart = await cartResponse.json();
                const thresholdCents = getDynamicThresholdCents();
                const isFreeShipping = thresholdCents !== null && cart.total_price >= thresholdCents;

                if (shippingRates.length > 0) {
                    let optionsHTML = '';
                    shippingRates.forEach(function (rate) {
                        const price = rate.price.replace('.', ',');
                        const priceCents = rate.price;
                        const deliveryLabel = getDeliveryLabel(rate);
                        optionsHTML += `
                            <div class="ec-shipping-select-option" data-price="${priceCents}" data-name="${rate.name}" data-delivery="${deliveryLabel}" role="option">
                                <span class="ec-shipping-radio"></span>
                                <div class="ec-shipping-option-content">
                                    <span class="ec-shipping-option-name">${rate.name}</span>
                                    <span class="ec-shipping-option-delivery">${deliveryLabel}</span>
                                </div>
                                <span class="ec-shipping-option-price">${isFreeShipping ? 'Grátis' : 'R$ ' + price}</span>
                            </div>
                        `;
                    });
                    shippingResult.innerHTML = `<div class="ec-shipping-options-list" role="listbox">${optionsHTML}</div>`;
                    setFreeShippingBarRevealed(true, true);
                    updateFreeShippingBarUI(cart.total_price);

                    const selectOptions = shippingResult.querySelectorAll('.ec-shipping-select-option');
                    selectOptions.forEach(option => {
                        option.addEventListener('click', function () {
                            applySelection(this);
                        });
                    });
                } else {
                    shippingResult.innerHTML = '<div class="ec-shipping-error">Nenhuma opção de frete disponível para este CEP.</div>';
                }
            } catch (error) {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro ao obter opções de frete.</div>';
                console.error('Erro:', error);
            } finally {
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
            }
        });

        if (zipCodeInput) {
            zipCodeInput.addEventListener('input', function (e) {
                this.classList.remove('error');
                const shippingResult = document.getElementById('ec-cart-shipping-result');
                if (shippingResult) {
                    shippingResult.innerHTML = '';
                }
                var digits = this.value.replace(/\D/g, '');
                if (digits.length === 8) {
                    calculateButton.click();
                } else if (digits.length === 0) {
                    setFreeShippingBarRevealed(false, true);
                }
            });

            zipCodeInput.addEventListener('blur', function (e) {
                const zipCode = this.value.replace(/\D/g, '');
                if (zipCode.length > 0 && zipCode.length !== 8) {
                    this.classList.add('error');
                    const shippingResult = document.getElementById('ec-cart-shipping-result');
                    if (shippingResult) {
                        shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                    }
                }
            });
        }

        const changeCepButton = document.getElementById('ec-cart-change-cep');
        if (changeCepButton) {
            changeCepButton.addEventListener('click', function () {
                const inputGroup = document.getElementById('ec-cep-input-group');
                const freteSelected = document.getElementById('ec-cart-frete-selected');
                const shippingResult = document.getElementById('ec-cart-shipping-result');

                if (inputGroup && freteSelected) {
                    inputGroup.style.display = 'flex';
                    freteSelected.style.display = 'none';
                    setFreeShippingBarRevealed(false, true);
                    try {
                        sessionStorage.removeItem('ec_region_threshold');
                        sessionStorage.removeItem('ec_calculated_uf');
                    } catch (e) { }

                    window.selectedShippingPrice = null;
                    window.selectedShippingName = null;
                    window.selectedShippingDelivery = null;

                    if (shippingResult) {
                        shippingResult.innerHTML = '';
                        shippingResult.style.display = 'block';
                    }

                    const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
                    if (shippingLine) {
                        shippingLine.style.display = 'none';
                    }

                    updateCartTotal();
                }
            });
        }
    }

    function updateShippingSummary(price) {
        const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
        const shippingValue = document.getElementById('ec-cart-shipping-value');
        const parsed = parseFloat(price);

        if (shippingLine && shippingValue) {
            if (isNaN(parsed)) {
                shippingLine.style.display = 'none';
                shippingValue.textContent = '';
            } else {
                shippingLine.style.display = 'flex';
                shippingValue.textContent = formatMoney(parsed);
            }
        }
    }

    function updateCartTotal() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(cart => {
                const totalValue = document.getElementById('ec-cart-total-value');
                const thresholdCents = getDynamicThresholdCents();
                const isFree = thresholdCents !== null && cart.total_price >= thresholdCents;

                updateFreeShippingBarUI(cart.total_price);

                let shippingPrice = parseFloat(window.selectedShippingPrice);
                if (isNaN(shippingPrice) || isFree) {
                    shippingPrice = 0;
                }

                const total = parseFloat(cart.total_price / 100) + shippingPrice;

                if (totalValue) {
                    totalValue.textContent = formatMoney(total);
                }

                const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
                const shippingValue = document.getElementById('ec-cart-shipping-value');
                const fretePrice = document.getElementById('ec-cart-frete-price');

                const parsedSelected = parseFloat(window.selectedShippingPrice);
                if (window.selectedShippingPrice !== null && window.selectedShippingPrice !== undefined && !isNaN(parsedSelected)) {
                    const priceToDisplay = isFree ? 0 : parsedSelected;
                    if (shippingLine && shippingValue) {
                        shippingLine.style.display = 'flex';
                        shippingValue.textContent = priceToDisplay === 0 ? 'Grátis' : formatMoney(priceToDisplay);
                    }
                    if (fretePrice) {
                        fretePrice.textContent = priceToDisplay === 0 ? 'Grátis' : formatMoney(priceToDisplay);
                    }
                } else {
                    if (shippingLine) {
                        shippingLine.style.display = 'none';
                    }
                    if (shippingValue) {
                        shippingValue.textContent = '';
                    }
                    if (fretePrice) {
                        fretePrice.textContent = '';
                    }
                }
            })
            .catch(err => console.error('Erro ao atualizar total:', err));
    }

    function formatMoney(cents) {
        const val = parseFloat(cents);
        if (isNaN(val) || !isFinite(val)) {
            return 'R$ 0,00';
        }
        return 'R$ ' + val.toFixed(2).replace('.', ',');
    }

    function ecResetFreteUiToInitial() {
        var inputGroup = document.getElementById('ec-cep-input-group');
        var freteSelected = document.getElementById('ec-cart-frete-selected');
        var shippingResult = document.getElementById('ec-cart-shipping-result');
        var shippingLine = document.getElementById('ec-cart-footer-shipping-line');
        var cep = document.getElementById('ec-cep-input');
        if (inputGroup) {
            inputGroup.style.display = '';
        }
        if (freteSelected) {
            freteSelected.style.display = 'none';
        }
        if (shippingResult) {
            shippingResult.innerHTML = '';
            shippingResult.style.display = '';
        }
        if (shippingLine) {
            shippingLine.style.display = 'none';
        }
        if (cep) {
            cep.value = '';
            cep.classList.remove('error');
        }
    }

    window.ecResetCartDrawerShippingClientState = function (opts) {
        opts = opts || {};
        if (!opts.skipDom) {
            try {
                sessionStorage.removeItem(EC_FREE_SHIPPING_BAR_SESSION);
                sessionStorage.removeItem('ec_region_threshold');
                sessionStorage.removeItem('ec_calculated_uf');
            } catch (e) { }
            window.selectedShippingPrice = null;
            window.selectedShippingName = null;
            window.selectedShippingDelivery = null;
            setFreeShippingBarRevealed(false, false);
            ecResetFreteUiToInitial();
        }
        updateCartTotal();
    };

    var EC_CHECKOUT_INJECTED_NAMES = [
        'checkout[shipping_address][zip]',
        'checkout[shipping_address][province]',
        'checkout[shipping_address][country]'
    ];

    function ecRemoveInjectedCheckoutFields() {
        const forms = [
            document.getElementById('CartDrawer-Form'),
            document.getElementById('cart')
        ].filter(Boolean);
        forms.forEach(form => {
            EC_CHECKOUT_INJECTED_NAMES.forEach(name => {
                const el = form.querySelector('input[name="' + name + '"]');
                if (el) el.remove();
            });
        });
    }

    window.syncCheckoutAddressInputs = function (cep, province) {
        ecRemoveInjectedCheckoutFields();
    };

    function normalizeZipCode(rawZipCode) {
        var digits = String(rawZipCode || '').replace(/\D/g, '');
        if (digits.length !== 8) {
            return null;
        }
        return digits.slice(0, 5) + '-' + digits.slice(5);
    }
    window.ecNormalizeZipCode = normalizeZipCode;

    var EC_ASYNC_RATES_MAX_ATTEMPTS = 16;
    var EC_ASYNC_RATES_INTERVAL_MS = 500;

    function buildShippingQuery(zipCode, province) {
        return 'shipping_address[zip]=' + encodeURIComponent(zipCode) +
            '&shipping_address[country]=BR' +
            '&shipping_address[province]=' + encodeURIComponent(province);
    }

    function delay(ms) {
        return new Promise(function (resolve) {
            setTimeout(resolve, ms);
        });
    }

  
    async function fetchShippingRates(zipCode, province) {
        const query = buildShippingQuery(zipCode, province);

        try {
            await fetch('/cart/prepare_shipping_rates.json?' + query, { method: 'POST' });

            for (let attempt = 0; attempt < EC_ASYNC_RATES_MAX_ATTEMPTS; attempt++) {
                await delay(EC_ASYNC_RATES_INTERVAL_MS);

                const res = await fetch('/cart/async_shipping_rates.json?' + query);
                if (!res.ok) break;

                const data = await res.json();
                // shipping_rates === null significa "ainda calculando".
                if (data && data.shipping_rates !== null && data.shipping_rates !== undefined) {
                    if (data.shipping_rates.length > 0) {
                        return data.shipping_rates;
                    }
                    break;
                }
            }
        } catch (e) {
            // cai no sincrono abaixo
        }

        // Fallback: se o assincrono falhar ou nao retornar nada, ainda e melhor
        // mostrar o rate generico do que travar o checkout.
        const res = await fetch('/cart/shipping_rates.json?' + query);
        const data = await res.json();
        return (data && data.shipping_rates) || [];
    }
    window.ecFetchShippingRates = fetchShippingRates;

    function isGenericRate(rate) {
        return !!rate && (rate.source === 'shopify_provided_generic_layer' || rate.code === 'backup_rate');
    }
    window.ecIsGenericShippingRate = isGenericRate;

    // O payload nao possui delivery_time. O prazo real vem em delivery_range
    // (par de datas) ou delivery_days (lista de dias uteis).
    function getDeliveryLabel(rate) {
        if (!rate) return 'Consultar';

        if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
            const days = rate.delivery_days
                .map(function (d) { return parseInt(d, 10); })
                .filter(function (d) { return !isNaN(d); });
            if (days.length > 0) {
                const maxDays = Math.max.apply(null, days);
                return 'Chega em até ' + maxDays + (maxDays === 1 ? ' dia útil' : ' dias úteis');
            }
        }

        if (Array.isArray(rate.delivery_range) && rate.delivery_range.length > 0) {
            const last = rate.delivery_range[rate.delivery_range.length - 1];
            const parsed = new Date(last);
            if (!isNaN(parsed.getTime())) {
                return 'Chega até ' + parsed.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit'
                });
            }
        }

        return 'Consultar';
    }
    window.ecGetShippingDeliveryLabel = getDeliveryLabel;

    async function resolveShippingForZip(rawZipCode) {
        var zipCode = normalizeZipCode(rawZipCode);
        if (!zipCode) {
            throw new Error('CEP inválido');
        }

        let province = '';
        const viaCepRes = await fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`);
        const viaCepData = await viaCepRes.json();

        if (viaCepData && viaCepData.uf) {
            province = viaCepData.uf.toUpperCase();
            try {
                sessionStorage.setItem('ec_calculated_uf', province);
                sessionStorage.setItem('ec_calculated_cep', zipCode);
            } catch (e) { }

            const barEl = document.getElementById('ec-free-shipping-bar');
            let thresholdCents = null;
            if (barEl) {
                const val = parseInt(barEl.getAttribute('data-threshold-cents'), 10);
                if (!isNaN(val)) thresholdCents = val;
            }
            const rules = getRegionRules();
            let matched = false;
            if (rules.region1.states.includes(province)) {
                thresholdCents = rules.region1.threshold * 100;
                matched = true;
            } else if (rules.region2.states.includes(province)) {
                thresholdCents = rules.region2.threshold * 100;
                matched = true;
            } else if (rules.region3.states.includes(province)) {
                thresholdCents = rules.region3.threshold * 100;
                matched = true;
            }
            try {
                if (matched) {
                    sessionStorage.setItem('ec_region_threshold', thresholdCents.toString());
                } else {
                    sessionStorage.removeItem('ec_region_threshold');
                }
            } catch (e) { }
        } else {
            throw new Error('Não foi possível determinar o estado para o CEP fornecido.');
        }

        const shippingRates = await fetchShippingRates(zipCode, province);

        return {
            province: province,
            shippingRates: shippingRates
        };
    }
    window.ecResolveShippingForZip = resolveShippingForZip;

    window.ecGetShippingSelection = function () {
        let cepValue = '';
        try {
            cepValue = sessionStorage.getItem('ec_calculated_cep') || '';
        } catch (e) {}
        if (!cepValue) {
            const zipCodeInput = document.getElementById('ec-cep-input') || document.getElementById('cart-cep');
            cepValue = zipCodeInput ? zipCodeInput.value.replace(/\D/g, '') : '';
        }
        if (window.selectedShippingPrice === null || window.selectedShippingPrice === undefined) {
            return null;
        }
        const parsedPrice = parseFloat(window.selectedShippingPrice);
        if (isNaN(parsedPrice)) {
            return null;
        }
        return {
            price: parsedPrice,
            name: window.selectedShippingName || '',
            delivery: window.selectedShippingDelivery || '',
            cep: cepValue
        };
    };

    window.ecShippingCalculatorState = {
        save: function () {
            const cepInput = document.getElementById('ec-cep-input');
            if (!cepInput) return;

            const inputGroup = document.getElementById('ec-cep-input-group');
            const freteSelected = document.getElementById('ec-cart-frete-selected');
            const shippingResult = document.getElementById('ec-cart-shipping-result');
            const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
            const shippingValue = document.getElementById('ec-cart-shipping-value');
            const freteCep = document.getElementById('ec-cart-frete-cep');
            const fretePrice = document.getElementById('ec-cart-frete-price');
            const freeShippingHost = document.getElementById('ec-free-shipping-bar-host');

            this.saved = {
                selectedShippingPrice: window.selectedShippingPrice !== undefined ? window.selectedShippingPrice : null,
                selectedShippingName: window.selectedShippingName !== undefined ? window.selectedShippingName : null,
                selectedShippingDelivery: window.selectedShippingDelivery !== undefined ? window.selectedShippingDelivery : null,
                cepValue: cepInput ? cepInput.value : '',
                inputGroupDisplay: inputGroup ? inputGroup.style.display : '',
                freteSelectedDisplay: freteSelected ? freteSelected.style.display : '',
                shippingResultHTML: shippingResult ? shippingResult.innerHTML : '',
                shippingResultDisplay: shippingResult ? shippingResult.style.display : '',
                shippingLineDisplay: shippingLine ? shippingLine.style.display : '',
                shippingValueText: shippingValue ? shippingValue.textContent : '',
                freteCepText: freteCep ? freteCep.textContent : '',
                fretePriceText: fretePrice ? fretePrice.textContent : '',
                freeShippingRevealed: freeShippingHost ? !freeShippingHost.hidden : false
            };
        },
        restore: function () {
            if (!this.saved) return;

            window.selectedShippingPrice = this.saved.selectedShippingPrice;
            window.selectedShippingName = this.saved.selectedShippingName;
            window.selectedShippingDelivery = this.saved.selectedShippingDelivery;

            const cepInput = document.getElementById('ec-cep-input');
            const inputGroup = document.getElementById('ec-cep-input-group');
            const freteSelected = document.getElementById('ec-cart-frete-selected');
            const shippingResult = document.getElementById('ec-cart-shipping-result');
            const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
            const shippingValue = document.getElementById('ec-cart-shipping-value');
            const freteCep = document.getElementById('ec-cart-frete-cep');
            const fretePrice = document.getElementById('ec-cart-frete-price');

            if (this.saved.freeShippingRevealed) {
                setFreeShippingBarRevealed(true, true);
            }

            if (cepInput) cepInput.value = this.saved.cepValue;
            if (inputGroup) inputGroup.style.display = this.saved.inputGroupDisplay;
            if (freteSelected) freteSelected.style.display = this.saved.freteSelectedDisplay;
            if (shippingResult) {
                shippingResult.innerHTML = this.saved.shippingResultHTML;
                shippingResult.style.display = this.saved.shippingResultDisplay;
            }
            if (shippingLine) shippingLine.style.display = this.saved.shippingLineDisplay;
            if (shippingValue) shippingValue.textContent = this.saved.shippingValueText;
            if (freteCep) freteCep.textContent = this.saved.freteCepText;
            if (fretePrice) fretePrice.textContent = this.saved.fretePriceText;

            if (shippingResult) {
                const selectOptions = shippingResult.querySelectorAll('.ec-shipping-select-option');
                selectOptions.forEach(option => {
                    option.addEventListener('click', function () {
                        if (typeof globalApplySelection === 'function') {
                            globalApplySelection(this);
                        }
                    });
                });
            }
            updateCartTotal();
        }
    };

    window.ecRemoveInjectedCheckoutFields = ecRemoveInjectedCheckoutFields;

    if (!window.__EC_CHECKOUT_FIELDS_SUBMIT_GUARD) {
        window.__EC_CHECKOUT_FIELDS_SUBMIT_GUARD = true;
        document.addEventListener('submit', function (e) {
            const form = e.target;
            if (form && (form.id === 'cart' || form.id === 'CartDrawer-Form')) {
                ecRemoveInjectedCheckoutFields();
            }
        }, true);
    }

    if (!window.__EC_SHIPPING_CALC_OBSERVED) {
        window.__EC_SHIPPING_CALC_OBSERVED = true;
        const observer = new MutationObserver(() => {
            ecRemoveInjectedCheckoutFields();
            initShippingCalculator();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            ecRemoveInjectedCheckoutFields();
            initShippingCalculator();
        });
    } else {
        ecRemoveInjectedCheckoutFields();
        initShippingCalculator();
    }

})();
